export default __webpack_public_path__ + "static/media/loading.00e80c2c.svg";